import React, { useState } from 'react';

interface ExecutionDateModalProps {
  isOpen: boolean;
  onClose: () => void;
  onConfirm: (startDate: string, endDate: string) => void;
  pipelineName?: string;
}

const ExecutionDateModal: React.FC<ExecutionDateModalProps> = ({
  isOpen,
  onClose,
  onConfirm,
  pipelineName
}) => {
  const [startDate, setStartDate] = useState<string>('');
  const [endDate, setEndDate] = useState<string>('');

  // Set default dates (last 7 days)
  React.useEffect(() => {
    if (isOpen) {
      const today = new Date();
      const sevenDaysAgo = new Date(today);
      sevenDaysAgo.setDate(today.getDate() - 7);
      
      // Format as YYYY-MM-DD for date input
      const formatDate = (date: Date) => {
        const year = date.getFullYear();
        const month = String(date.getMonth() + 1).padStart(2, '0');
        const day = String(date.getDate()).padStart(2, '0');
        return `${year}-${month}-${day}`;
      };
      
      setStartDate(formatDate(sevenDaysAgo));
      setEndDate(formatDate(today));
    }
  }, [isOpen]);

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    
    if (!startDate || !endDate) {
      return;
    }

    // Validate dates (compare as strings in YYYY-MM-DD format)
    if (startDate > endDate) {
      alert('Start date must be before end date');
      return;
    }

    // Send dates as strings in YYYY-MM-DD format
    onConfirm(startDate, endDate);
    // Reset form
    setStartDate('');
    setEndDate('');
  };

  const handleCancel = () => {
    setStartDate('');
    setEndDate('');
    onClose();
  };

  if (!isOpen) return null;

  return (
    <div className="modal-overlay">
      <div className="modal-content">
        <div className="modal-header">
          <h3>{pipelineName ? `Run: ${pipelineName}` : 'Set Date Range'}</h3>
          <button onClick={handleCancel} className="close-button">&times;</button>
        </div>
        
        <form onSubmit={handleSubmit}>
          <div className="form-group">
            <label htmlFor="startDate">Start Date:</label>
            <input
              type="date"
              id="startDate"
              value={startDate}
              onChange={(e) => setStartDate(e.target.value)}
              required
            />
          </div>

          <div className="form-group">
            <label htmlFor="endDate">End Date:</label>
            <input
              type="date"
              id="endDate"
              value={endDate}
              onChange={(e) => setEndDate(e.target.value)}
              required
            />
          </div>

          <div className="modal-actions">
            <button type="button" onClick={handleCancel}>Cancel</button>
            <button type="submit">Confirm</button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default ExecutionDateModal;

